// src/config/permissions.js
// กำหนดสิทธิ์การเข้าถึงแต่ละ route และเมนูตาม role
// export const ROLES = {
//   ADMIN: "admin",
//   FINANCE: "finance",
//   USER: "user",
// };

// กำหนดว่า route ไหน role ไหนเข้าได้บ้าง
// ถ้าไม่ระบุ roles = ทุก role ที่ login แล้วเข้าได้
// export const ROUTE_PERMISSIONS = {
//   dashboard: [ROLES.ADMIN, ROLES.FINANCE, ROLES.USER],
//   units: [ROLES.ADMIN],
//   "unit-detail": [ROLES.ADMIN],
//   residents: [ROLES.ADMIN, ROLES.FINANCE],
//   "resident-detail": [ROLES.ADMIN, ROLES.FINANCE],
//   "resident-my-detail": [ROLES.ADMIN, ROLES.FINANCE, ROLES.USER],
//   invoices: [ROLES.ADMIN, ROLES.FINANCE],
//   "invoice-detail": [ROLES.ADMIN, ROLES.FINANCE],
//   payments: [ROLES.ADMIN, ROLES.FINANCE],
//   "payment-create": [ROLES.ADMIN, ROLES.FINANCE],
//   "payment-detail": [ROLES.ADMIN, ROLES.FINANCE],
//   arrears: [ROLES.ADMIN, ROLES.FINANCE],
//   reports: [ROLES.ADMIN], // เฉพาะ admin เท่านั้น
// };

// กำหนดเมนู Sidebar พร้อม roles ที่มองเห็นได้
// export const MENU_ITEMS = (auth) => [
//   {
//     label: "Dashboard",
//     to: "/dashboard",
//     icon: "bi-speedometer2",
//     roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.USER],
//   },
//   {
//     label: "ยูนิต / บ้าน / ห้อง",
//     to: "/units",
//     icon: "bi-buildings",
//     roles: [ROLES.ADMIN],
//   },
//   {
//     label: "ลูกบ้าน",
//     to: "/residents",
//     icon: "bi-people",
//     roles: [ROLES.ADMIN, ROLES.FINANCE],
//   },
//   {
//     label: "ของฉัน",
//     to: auth.user?.username
//       ? `/resident-detail/${auth.user.username}`
//       : "/dashboard",
//     icon: "bi-house-fill",
//     roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.USER],
//   },
//   {
//     label: "ใบแจ้งหนี้",
//     to: "/invoices",
//     icon: "bi-receipt-cutoff",
//     roles: [ROLES.ADMIN, ROLES.FINANCE],
//   },
//   {
//     label: "รับชำระเงิน",
//     to: "/payments",
//     icon: "bi-cash-coin",
//     roles: [ROLES.ADMIN, ROLES.FINANCE],
//   },
//   {
//     label: "ค้างชำระ",
//     to: "/arrears",
//     icon: "bi-exclamation-diamond",
//     roles: [ROLES.ADMIN, ROLES.FINANCE],
//   },
//   {
//     label: "รายงาน",
//     to: "/reports",
//     icon: "bi-bar-chart",
//     roles: [ROLES.ADMIN],
//   },
// ];

export const ROLES = {
  ADMIN: "admin",
  FINANCE: "finance",
  USER: "user",
};

export const ROUTE_PERMISSIONS = {
  dashboard: [ROLES.ADMIN, ROLES.FINANCE, ROLES.USER],
  units: [ROLES.ADMIN],
  "unit-detail": [ROLES.ADMIN],
  residents: [ROLES.ADMIN, ROLES.FINANCE],
  "resident-detail": [ROLES.ADMIN, ROLES.FINANCE],
  "resident-my-detail": [ROLES.USER],
  invoices: [ROLES.ADMIN, ROLES.FINANCE],
  "invoice-detail": [ROLES.ADMIN, ROLES.FINANCE],
  payments: [ROLES.ADMIN, ROLES.FINANCE],
  "payment-create": [ROLES.ADMIN, ROLES.FINANCE],
  "payment-detail": [ROLES.ADMIN, ROLES.FINANCE],
  arrears: [ROLES.ADMIN, ROLES.FINANCE],
  reports: [ROLES.ADMIN],
};

export const getMenuItems = (auth) => [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: "bi-speedometer2",
    roles: [ROLES.ADMIN, ROLES.FINANCE, ROLES.USER],
  },
  {
    label: "ยูนิต / บ้าน / ห้อง",
    to: "/units",
    icon: "bi-buildings",
    roles: [ROLES.ADMIN],
  },
  {
    label: "ลูกบ้าน",
    to: "/residents",
    icon: "bi-people",
    roles: [ROLES.ADMIN, ROLES.FINANCE],
  },
  {
    label: "ของฉัน",
    to: auth.user?.username
      ? `/resident-detail/${auth.user.username}`
      : "/dashboard",
    icon: "bi-house-fill",
    roles: [ROLES.USER],
  },
  {
    label: "ใบแจ้งหนี้",
    to: "/invoices",
    icon: "bi-receipt-cutoff",
    roles: [ROLES.ADMIN, ROLES.FINANCE],
  },
  {
    label: "รับชำระเงิน",
    to: "/payments",
    icon: "bi-cash-coin",
    roles: [ROLES.ADMIN, ROLES.FINANCE],
  },
  {
    label: "ค้างชำระ",
    to: "/arrears",
    icon: "bi-exclamation-diamond",
    roles: [ROLES.ADMIN, ROLES.FINANCE],
  },
  {
    label: "รายงาน",
    to: "/reports",
    icon: "bi-bar-chart",
    roles: [ROLES.ADMIN],
  },
];
